const getParentWindows = (existingWindows = [window]) => {
  const lastWindow = existingWindows[existingWindows.length - 1];

  if (lastWindow === lastWindow.parent) return existingWindows;

  return getParentWindows([...existingWindows, lastWindow.parent]);
};

const postMessageToFrame = (
  { seller, checkout, query, type, iframeId, initialCheckout, payload },
  targetOrigin = '*',
) => {
  const windows = getParentWindows();

  windows.forEach(w => {
    w.postMessage(
      {
        seller,
        checkout,
        iframeId,
        initialCheckout,
        query,
        type,
        payload,
      },
      targetOrigin || '*',
    );
  });
};

export default postMessageToFrame;
